// ===========================================================================
// RoleRoute - role-based route guard, parallel to FeatureRoute.
//
// Layout.jsx hides nav items by role, but the URL itself is still routable
// without this guard. Without RoleRoute, an authenticated user can deep-link
// to a page the sidebar would have hidden from them - either by typing the
// URL or by the browser restoring it after a session expires.
//
// Usage:
//   <Route path="/some-page" element={
//     <RoleRoute allow={["Owner","Manager"]}>
//       <SomePage />
//     </RoleRoute>
//   } />
//
// While the auth profile is loading we render nothing rather than briefly
// flashing the gated content. Disallowed roles get redirected to /dashboard
// (the universal landing).
// ===========================================================================

import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export default function RoleRoute({ allow, children }) {
  const { role, profile } = useAuth();
  // Profile not yet loaded - render nothing rather than flashing
  if (!profile) return null;
  if (!allow.includes(role)) return <Navigate to="/dashboard" replace />;
  return children;
}
